'use strict';

export const flagColors = [
	'#ddd',
	'#f75c50',
	'#ffb200',
	'#efe27e',
	'#459045',
	'#6db5ff',
	'#9078fc',
	'#9d7044',
	'#161616',
];

export const priorityColors = [
	'#ddd',
	'#f75c50',
	'#ffb200',
];

export const waypointsFromAssigned = assigned =>
	assigned.map(({ property }, i) => {

		const { placeId } = property;

		return {
			location: { placeId },
			stopover: false
		};
	}).filter(wp => wp);

export const geosFromAssigned = (google, assigned) => 
	assigned.map((job, i) => {

		const [ lat, lng ] = job.property.geo;
		return new google.maps.LatLng(lat, lng);
	});

export const partitionWaypoints = waypoints => {

	const partitions = [];

	for (let i = 0; i < waypoints.length; i += 24) {
		partitions.push(waypoints.slice(i, i + 24 + 1));
	}
	
	return partitions;
};

export const getPartitions = locationPartitions => locationPartitions.map(
	bucket => bucket.map(({ placeId }) => ({
		location: { placeId },
		stopover: false,
	}))
);
